import React, { useContext, useEffect } from "react";
import Context from "../context/CartContext.jsx";
import EnviarWhatsapp from "./EnviarWhatsapp.jsx";
import EnviarExcelTabla from "./EnviarExcelTabla.jsx";
import ProveedorContext from "../context/ProveedorContext.jsx";
import NavbarVolver from "./navbarVolver.jsx";

export default function MostrarCarro() {
  const { cart } = useContext(Context);
  const { proveedorContext } = useContext(ProveedorContext);

  useEffect(() => {
    const backdrop = document.querySelector(".fixed.inset-0");
    if (backdrop) backdrop.remove();
  }, []);

  const totalItems = cart.reduce((sum, p) => sum + p.cantidad, 0);

  return (
    <>
      <NavbarVolver />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
        <h1 className="page-title">Confirmacion de Pedido</h1>

        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <div className="max-h-[500px] overflow-y-auto">
              <table className="w-full">
                <thead className="sticky top-0 z-10">
                  <tr className="table-header">
                    <th className="px-4 py-3 text-left">Imagen</th>
                    <th className="px-4 py-3 text-left">Nombre</th>
                    <th className="px-4 py-3 text-left">Marca</th>
                    <th className="px-4 py-3 text-center">Cantidad</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((producto) =>
                    producto.cantidad === 0 ? null : (
                      <tr key={producto.id_producto} className="table-row">
                        <td className="px-4 py-3">
                          <img
                            src={
                              "https://storage.googleapis.com/imagenes-ponsrazas/" +
                              producto.imagen
                            }
                            alt={producto.producto_nombre}
                            className="h-16 w-16 object-contain rounded-lg bg-surface-muted p-1"
                          />
                        </td>
                        <td className="px-4 py-3">
                          <span className="text-sm font-semibold text-ink">
                            {producto.producto_nombre} {producto.numeracion} {producto.medidaOficial}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <span className="text-sm text-ink-muted">{producto.marca_nombre}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-pons-200 text-pons-800 font-bold text-sm">
                            {producto.cantidad}
                          </span>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="border-t border-surface-border bg-surface-muted/50 px-4 py-3">
            <p className="text-sm text-ink-muted">
              Total: <span className="font-bold text-ink">{totalItems} productos</span>
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {proveedorContext[0].telefono && proveedorContext[0].telefono !== "0" && proveedorContext[0].telefono !== 0 && (
            <EnviarWhatsapp telefono={proveedorContext[0].telefono} />
          )}
          <EnviarExcelTabla
            proveedor={proveedorContext[0].nombre}
            idProveedor={proveedorContext[0].id}
          />
        </div>
      </div>
    </>
  );
}
